import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Modal, Tab, Nav } from 'react-bootstrap'
import Card from '../../../../components/Card'
import { Link, useNavigate, Route } from 'react-router-dom'
import Moment from 'moment';
import { apiHandler, getApiErrorMessage } from '../../../../api/apihandler';
import { EVENT_LIST, FEEDS_DETAIL } from "../../../../api/constants";
import { InView } from "react-intersection-observer";
import Swal from 'sweetalert2'

// Redux Selector / Action
import { useSelector } from 'react-redux';

//profile-header
import ProfileHeader from '../../../../components/profile-header'

// images
import img3 from '../../../../assets/images/page-img/profile-bg3.jpg'
import img6 from '../../../../assets/images/page-img/profile-bg6.jpg'
import loader from '../../../../assets/images/page-img/page-load-loader.gif'
import EventCard from '../../../../components/event/eventCard';
import NoDataFound from '../../../../components/noDataFound';

const Events = () => {
   const navigate = useNavigate();
   let generalSettingsData = (useSelector((state) => state.setting.setting.general_settings))
   generalSettingsData = generalSettingsData ? JSON.parse(generalSettingsData) : "";

   const [upcomingEventList, setUpcomingEventList] = useState([]);
   const [upcomingPage, setUpcomingPage] = useState(1);
   const [upcomingMaxPage, setUpcomingMaxPage] = useState(1);
   const [pastEventList, setPastEventList] = useState([]);
   const [pastPage, setPastPage] = useState(1);
   const [pastMaxPage, setPastMaxPage] = useState(1);
   const [isPast, setIsPast] = useState(false);
   const [showMoreDataLoader, setShowMoreDataLoader] = useState(false);

   const [isFirst, setIsFirst] = useState(true);
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setIsFirst(false)
    }, [isFirst]);

   useEffect(() => {
      getUpcomingEventList(1)
   }, []);

   useEffect(() => {
      if (isPast)
         pastRefreshApi()
      else
         upcomingRefreshApi()
   }, [isPast]);

   function upcomingRefreshApi() {
      setUpcomingPage(1)
      getUpcomingEventList(1)
   }

   const upcomingLoadMore = (inView) => {
      if (inView) {
         if (upcomingPage < upcomingMaxPage) {
            getUpcomingEventList(upcomingPage + 1)
            setUpcomingPage(upcomingPage + 1)
         }
      }
   };

   function pastRefreshApi() {
      setPastPage(1)
      getPastEventList(1)
   }

   const pastLoadMore = (inView) => {
      if (inView) {
         if (pastPage < pastMaxPage) {
            getPastEventList(pastPage + 1)
            setPastPage(pastPage + 1)
         }
      }
   };

   async function getUpcomingEventList(pageVal) {
      setShowMoreDataLoader(true)
      try {
         const res = await apiHandler(EVENT_LIST, "POST", {
            page: pageVal,
            limit: 10,
            type: "upcoming"
         })
         if (res.data?.response?.status === 200) {
            setUpcomingMaxPage(res?.data?.data?.events?.meta?.last_page)
            if (res?.data?.data?.events?.meta?.total > 0) {
               if (pageVal === 1) {
                  setUpcomingEventList(res?.data?.data?.events?.data)
               } else {
                  setUpcomingEventList(upcomingEventList.concat(res?.data?.data?.events?.data))
               }
            }
         } else {
            //navigate('/auth/sign-in')
            Swal.fire({
               title: 'Error',
               text: getApiErrorMessage(res, 'Failed to load events. Please try again.'),
               icon: 'error',
               confirmButtonText: 'Okay'
            })
         }
      } catch (error) {
         console.error(error);
      }
      finally {
         setShowMoreDataLoader(false)
      }
   }

   async function getPastEventList(pageVal) {
      setShowMoreDataLoader(true)
      try {
         const res = await apiHandler(EVENT_LIST, "POST", {
            page: pageVal,
            limit: 10,
            type: "past"
         })
         if (res.data?.response?.status === 200) {
            setPastMaxPage(res?.data?.data?.events?.meta?.last_page)
            if (res?.data?.data?.events?.meta?.total > 0) {
               if (pageVal === 1) {
                  setPastEventList(res?.data?.data?.events?.data)
               } else {
                  setPastEventList(pastEventList.concat(res?.data?.data?.events?.data))
               }
            }
         } else {
            //navigate('/auth/sign-in')
            Swal.fire({
               title: 'Error',
               text: getApiErrorMessage(res, 'Failed to load events. Please try again.'),
               icon: 'error',
               confirmButtonText: 'Okay'
            })
         }
      } catch (error) {
         console.error(error);
      }
      finally {
         setShowMoreDataLoader(false)
      }
   }



   return (
      <>
         <ProfileHeader title= {generalSettingsData?.event_heading_text + " List"} img={img6} />
         <div id="content-page" className="content-page">
            <Container>
               <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Card className="p-0">
                     <Card.Body className="p-0">
                        <div className="user-tabing">
                           <Nav as="ul" variant="pills" className="d-flex align-items-center justify-content-center profile-feed-items p-0 m-0">
                              <Nav.Item as="li" className=" col-12 col-sm-6 p-0 " onClick={()=> setIsPast(false)}>
                                 <Nav.Link href="#upcomming-tab" eventKey="first" role="button" className=" text-center p-3">Upcoming</Nav.Link>
                              </Nav.Item>
                              <Nav.Item as="li" className="col-12 col-sm-6 p-0" onClick={()=> setIsPast(true)}>
                                 <Nav.Link href="#past-tab" eventKey="second" role="button" className="text-center p-3">Past</Nav.Link>
                              </Nav.Item>
                           </Nav>
                        </div>
                     </Card.Body>
                  </Card>
                  <Col sm={12}>
                     <Tab.Content>
                        <Tab.Pane eventKey="first" >
                           <Card.Body className=" p-0">
                              <Row>
                                 <Col lg={12}>
                                    <div className="d-grid gap-3 d-grid-template-1fr-19 mb-5">
                                       {
                                          upcomingEventList?.length > 0 ? upcomingEventList.map((elm, i) => (
                                             <EventCard elm={elm} getEventList={upcomingRefreshApi} key={elm?.id} isPast={false} />
                                          )) :
                                             <NoDataFound />}
                                    </div>
                                    {
                                       showMoreDataLoader ?
                                          <div className="col-sm-12 text-center">
                                             <img src={loader} alt="loader" style={{ height: "100px" }} />
                                          </div> : null
                                    }
                                    <InView as="div" onChange={(inView, entry) => upcomingLoadMore(inView)} />
                                 </Col>
                              </Row>
                           </Card.Body>
                        </Tab.Pane>
                     </Tab.Content>
                     <Tab.Content>
                        <Tab.Pane eventKey="second">
                           <Card.Body className=" p-0">
                              <Row>
                                 <Col lg={12}>
                                    <div className="d-grid gap-3 d-grid-template-1fr-19 mb-5">
                                       {
                                          pastEventList?.length > 0 ? pastEventList.map((elm, i) => (
                                             <EventCard elm={elm} getEventList={pastRefreshApi} key={elm?.id} isPast={true} />
                                          )) :
                                             <NoDataFound />}
                                    </div>
                                    {
                                       showMoreDataLoader ?
                                          <div className="col-sm-12 text-center">
                                             <img src={loader} alt="loader" style={{ height: "100px" }} />
                                          </div> : null
                                    }
                                    <InView as="div" onChange={(inView, entry) => pastLoadMore(inView)} />
                                 </Col>
                              </Row>
                           </Card.Body>
                        </Tab.Pane>
                     </Tab.Content>
                  </Col>
               </Tab.Container>
               {/* <div className="d-grid gap-3 d-grid-template-1fr-19 mb-5">
                  {
                     eventList?.length > 0 ? eventList.map((elm, i) => (
                        <EventCard elm={elm} getEventList={refreshApi} key={elm?.id} />
                     )) : null} */}

               {/* <div>
                        <Card className=" rounded  mb-0">
                           <div className="event-images">
                              <Link to="#">
                                 <img src={img51} className="img-fluid" alt="Responsive"/>
                              </Link>
                           </div>
                           <Card.Body>
                              <div className="d-flex">
                                 <div className="date-of-event">
                                    <span>Jan</span>
                                    <h5>01</h5>
                                 </div>
                                 <div className="events-detail ms-3">
                                    <h5><Link to="/dashboards/app/event-detail">New Year Celebration</Link></h5>
                                    <p>Lorem Ipsum is simply dummy text</p>
                                    <div className="event-member">
                                       <div className="iq-media-group">
                                          <Link to="#" className="iq-media">
                                             <img className="img-fluid avatar-40 rounded-circle" src={user05} alt=""/>
                                          </Link>
                                          <Link to="#" className="iq-media">
                                             <img className="img-fluid avatar-40 rounded-circle" src={user06} alt=""/>
                                          </Link>
                                          <Link to="#" className="iq-media">
                                             <img className="img-fluid avatar-40 rounded-circle" src={user07} alt=""/>
                                          </Link>
                                          <Link to="#" className="iq-media">
                                             <img className="img-fluid avatar-40 rounded-circle" src={user08} alt=""/>
                                          </Link>
                                          <Link to="#" className="iq-media">
                                             <img className="img-fluid avatar-40 rounded-circle" src={user09} alt=""/>
                                          </Link>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </Card.Body>
                        </Card>
                     </div> */}
               {/* </div>
               {
                  showMoreDataLoader ?
                     <div className="col-sm-12 text-center">
                        <img src={loader} alt="loader" style={{ height: "100px" }} />
                     </div> : null
               }
               <InView as="div" onChange={(inView, entry) => loadMore(inView)} /> */}
            </Container>
         </div>
      </>
   )

}

export default Events;